/**
 * Convert Tripetto @slotId references to Formly {{fieldKey}} references
 * Tripetto uses @slotId for variable interpolation, Formly uses {{fieldKey}}
 */
export function convertInterpolationReferences(
	text: string | undefined,
	slotLookup: Map<string, { alias?: string; nodeName?: string; slotId?: string }>
): string | undefined {
	if (!text) {
		return text;
	}

	// Find all @slotId references in the text
	// Tripetto format: @4bfef4363010c17fefcaafcab1dfae4f3933747329a93adb6575433d481cd4f9
	const interpolationRegex = /@([a-f0-9]{64})/g;

	let convertedText = text;
	const matches = text.match(interpolationRegex);

	if (matches && matches.length > 0) {
		for (const match of matches) {
			const slotId = match.substring(1); // Remove the @ prefix
			const slotInfo = slotLookup.get(slotId);

			if (slotInfo && slotInfo.alias) {
				// Replace @slotId with {{fieldKey}} using alias
				convertedText = convertedText.replace(match, `{{${slotInfo.alias}}}`);
			} else if (slotInfo && slotInfo.slotId) {
				// Use slot.id when no alias exists (will match the field key)
				convertedText = convertedText.replace(match, `{{${slotInfo.slotId}}}`);
			} else {
				// If somehow we can't find anything, use the slotId directly
				convertedText = convertedText.replace(match, `{{${slotId}}}`);
			}
		}
	}

	return convertedText;
}
